/* eslint-disable */
// WARNING: This file is generated during CI by scripts/write-aws-exports.js.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:412f871c-97a9-4e1f-95a5-2b362307a24e",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_GzkyUvzWd",
    "aws_user_pools_web_client_id": "6orvthkmh7hmusd7iao6it08eu",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL",
        "NAME"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_appsync_graphqlEndpoint": "https://t5y2iz5nxbgsxmd6zxtptsgvk4.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_dynamodb_all_tables_region": "us-east-1",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "dynamo4062985a-dev",
            "region": "us-east-1"
        }
    ],
    "aws_user_files_s3_bucket": "supplysgtapp143c061359bc4407bdefc8dd9b6c476ea792b-dev",
    "aws_user_files_s3_bucket_region": "us-east-1"
};

export default awsmobile;
